export class ItemStorage<T> {
  private value?: T
  constructor(
    private readonly name: string,
    private readonly container: Storage = localStorage
  ) {}

  get(): T | undefined {
    if (this.value) {
      return this.value
    }

    const stored = this.container.getItem(this.name)
    if (stored) {
      try {
        return (this.value = JSON.parse(stored))
      } catch (e) {
        this.set(stored as T)
        return (this.value = stored as T)
      }
    }
  }

  set(item: T): void {
    this.value = item
    this.container.setItem(this.name, JSON.stringify(item))
  }

  remove(): void {
    this.value = undefined
    this.container.removeItem(this.name)
  }

  get exist(): boolean {
    return !!this.get()
  }
}
